import { useParams } from 'react-router-dom';

import { useAppSelector } from 'app/hooks';
import { PalmDataGrid } from 'common/components/PalmDataGrid';
import { Roles } from 'common/constants/roles';
import { usePalmButtonEvaluator } from 'common/hooks/usePalmButtonEvaluator';
import { usePalmFetchEntitiesWithExtraReducers } from 'common/hooks/usePalmFetchEntitiesWithExtraReducers';
import { usePalmFilters } from 'common/hooks/usePalmFilters';
import { usePalmSortModel } from 'common/hooks/usePalmSortModel';
import { fetchAclResources } from 'common/services/api/Acls/AclResources.thunk';
import {
    ColumnDefinition,
    ColumnType,
    Operations } from 'common/types/TypeDefs';

import { selectEntities, selectError,selectProcessing } from '../aclResources/aclResourcesSlice';

import { AclResourcesCreateContent } from './AclResourcesCreateDrawerContent';
import { AclResourcesDeleteDialogContent } from './AclResourcesDeleteDialogContent';
import {
    addNewFilter,
    clearEntities,
    clearFilters,
    removeFilter,
    selectFilters } from './aclResourcesSlice';

export const AclResourcesTab = () => {

    const typeName = 'ACL Resource';
    const shouldDisableButtons = usePalmButtonEvaluator([ Roles.Admin, Roles.AppManager ]);
    const [sortModel, setSortModel] = usePalmSortModel('displayName');

    const params = useParams();
    const tenantId = params.tenantId;

    const filterProp = usePalmFilters(
        selectFilters,
        addNewFilter,
        removeFilter,
        clearFilters);

    const fetchEntities = usePalmFetchEntitiesWithExtraReducers(
        typeName,
        selectEntities,
        selectError,
        clearEntities,
        fetchAclResources,
        { tenantId: tenantId ?? '' });

    const processing = useAppSelector(selectProcessing);

    const actionDefinitions =  [
        { action: Operations.Edit, disabled: shouldDisableButtons },
        { action: Operations.Delete, disabled: shouldDisableButtons }
    ];

    const columnDefinitions: ColumnDefinition[] = [
        { columnId: 'id', columnName: 'ACL Resource ID', columnType: ColumnType.First, shouldFilterByExactMatch: true },
        { columnId: 'displayName', columnName: 'Resource Display Name', columnType: ColumnType.Tooltip },
        { columnId: 'name', columnName: 'Resource Name', columnType: ColumnType.Tooltip },
        { columnId: 'conditionsDisplay', columnName: 'ACL Conditions', columnType: ColumnType.Tooltip },
        { columnId: 'actions', columnName: 'Actions', columnType: ColumnType.Action, size: 0.3 }
    ];

    return <PalmDataGrid
        actionDefinitions={actionDefinitions}
        columnDefinitions={columnDefinitions}
        title='ACL Resource'
        deleteFunction={AclResourcesDeleteDialogContent}
        contentFunction={AclResourcesCreateContent}
        isCreateButtonDisabled={shouldDisableButtons}
        filter={filterProp}
        processing={processing}
        refreshDataGridClick={() => fetchEntities()}
        sortModel={sortModel}
        clientSortHandler={setSortModel}
        shouldShowExportButton={true}
    />;
};
